// src/pages/admin/settings/EditSystemUser.js
import React from 'react';
import { Layout, Form, Input, Button, Select, message } from 'antd'; // Added 'message'
import { useParams, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';

const { Content } = Layout;
const { Option } = Select;

const EditSystemUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = React.useState(false);
  const [form] = Form.useForm();

  const user = { id, name: 'Placeholder', email: 'placeholder@jecthub.com', role: 'ADMIN', phone: '555-0000' }; // Placeholder
  React.useEffect(() => {
    form.setFieldsValue(user);
  }, [form, user]);

  const roleOptions = [
    { label: 'Admin', value: 'ADMIN' },
    { label: 'Accountant', value: 'ACCOUNTANT' },
    { label: 'Support', value: 'SUPPORT' },
    { label: 'HR', value: 'HR' },
    { label: 'Operations', value: 'OPERATIONS' },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(`/admin/${key}`);
  };

  const handleSubmit = (values) => {
    console.log('Updated user:', { id, ...values }); // Placeholder: Update via API
    message.success(`User "${values.name}" updated successfully`); // Now works with 'message' imported
    navigate('/admin/system-users');
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} handleMenuClick={handleMenuClick} />
      <Layout>
        <Content style={{ margin: '16px', padding: '16px', background: '#fff' }}>
          <h2>Edit User: {user.name}</h2>
          <Form form={form} layout="vertical" onFinish={handleSubmit}>
            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please enter the name' }]}>
              <Input />
            </Form.Item>
            <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}>
              <Input />
            </Form.Item>
            <Form.Item name="phone" label="Phone" rules={[{ required: true, message: 'Please enter the phone number' }]}>
              <Input />
            </Form.Item>
            <Form.Item name="role" label="Role" rules={[{ required: true, message: 'Please select a role' }]}>
              <Select>
                {roleOptions.map((role) => (
                  <Option key={role.value} value={role.value}>
                    {role.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit">Save Changes</Button>
              <Button style={{ marginLeft: 8 }} onClick={() => navigate('/admin/system-users')}>Cancel</Button>
            </Form.Item>
          </Form>
        </Content>
      </Layout>
    </Layout>
  );
};

export default EditSystemUser;